import type { SVGProps } from 'react'
const LineWifi = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M12 5.5c3.604 0 6.994 1.405 9.544 3.955l1.06-1.06A14.9 14.9 0 0 0 12 4 14.9 14.9 0 0 0 1.394 8.395l1.06 1.06A13.41 13.41 0 0 1 11.999 5.5Zm-6.365 7.135-1.06-1.06A10.43 10.43 0 0 1 12 8.5c2.805 0 5.44 1.09 7.425 3.075l-1.06 1.06A8.94 8.94 0 0 0 12 10a8.94 8.94 0 0 0-6.365 2.635m6.364 1.865c1.2 0 2.33.47 3.18 1.32h.01l1.06-1.06a5.98 5.98 0 0 0-4.245-1.755c-1.605 0-3.11.62-4.245 1.755l1.06 1.06c.85-.85 1.98-1.32 3.18-1.32m1.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineWifi }
